import { assign, sendParent, setup } from 'xstate';
import { registerFilingCredentialActor } from './filingcredential.actors';
import type { FilingcredentialEvent } from './events';
import type { RegisterFilingCredentialInput } from '@/lib/gql/__generated__/graphql';

type FilingcredentialContext = { input: RegisterFilingCredentialInput; error?: string };

export const filingcredentialMachine = setup({
  types: { context: {} as FilingcredentialContext, events: {} as FilingcredentialEvent },
  actors: { registerFilingCredentialActor },
  actions: {
    rememberInput: assign(({ event }) => ({
      input: {
        filingCredentialId: crypto.randomUUID(),
        environment: event.environment,
        transmitterId: event.transmitterId,
      },
      error: undefined,
    })),
    announceSuccess: sendParent(({ context }) => ({
      type: 'filingcredential.registered',
      filingCredentialId: context.input.filingCredentialId,
    })),
    toastSuccess: sendParent({
      type: 'ui.toast.push',
      toast: { title: 'Filing credential registered', tone: 'success' },
    }),
    toastError: sendParent({
      type: 'ui.toast.push',
      toast: { title: 'Filing credential could not be registered', tone: 'error' },
    }),
  },
}).createMachine({
  id: 'filingcredential',
  initial: 'idle',
  context: { input: { filingCredentialId: '', environment: '', transmitterId: '' } },
  states: {
    idle: { on: { 'filingcredential.register': { target: 'registering', actions: 'rememberInput' } } },
    registering: {
      invoke: {
        src: 'registerFilingCredentialActor',
        input: ({ context }) => context.input,
        onDone: { target: 'idle', actions: ['toastSuccess', 'announceSuccess'] },
        onError: { target: 'error', actions: 'toastError' },
      },
    },
    error: { on: { 'filingcredential.register': { target: 'registering', actions: 'rememberInput' } } },
  },
});
